export default function removeMessageQuery(urlString: string) {
    const url = new URL(urlString)
    const removeGetIndex = url.search.indexOf("remove-get=true")
    if (removeGetIndex !== -1) {
        url.search = url.search.slice(0, removeGetIndex - 1)
    }
    return url.href
}
